const deployInfo = {
  // 公司测试服务器
  A: {
    apiAddress: window.location.origin + '/api',
    qdAddress: window.location.origin + '/api',
    // apiAddress: 'http://192.168.111.61:8005/api',
    // qdAddress: 'http://192.168.111.61:8005/api'
  },
  B: {
    apiAddress: window.location.origin + '/api',
    qdAddress: window.location.origin + '/api',
  },

}
/**
 * 192.168.2.54  24.114:9122  11.247
 * 江滨医院            9121  前端端口  8023
 * 区医院             9122  前端端口  8025
 * 公司测试            9123  前端端口  8026
 * 江滨医院杨华丹专用  9124  前端端口  8027
 */

// 标识是否是开发环境
export const env = process.env.NODE_ENV == 'development' ? 'A' : 'B'
export const hostsMap = {
  'dev': deployInfo[env].apiAddress,
  'test': deployInfo[env].apiAddress,
  // 如果小程序答题界面还在使用嵌套的 webview，pro 请使用 https，不要直接使用 ip
  'pro': deployInfo[env].apiAddress,
}

export const gateway = deployInfo[env].apiAddress

// 表单发布地址，当前先复用本项目内的公开答题页
export const shareQuestionnaire = window.location.origin + '/#/webAnswerPage/webAnswer?shareCode='; ''

// 创建量表时 image 题目的图片上传地址
export const imageTopicUploadFileUrl = hostsMap['pro'] + '/public/uploadFile';
export const imageTopicUploadFileUrlNew = hostsMap['pro'] + '/rest/file/uploadFile';

// image 题目的图片展示 url 前缀
export const imageTopicImgUrlPrefix = hostsMap['pro'] + '/upload'

// image 题目后面的图片展示 url 前缀
export const topicImage = (process.env.NODE_ENV == 'development' ? 'http://192.168.2.55:8025' : window.location.origin) + '/'

// 人脸图片展示前缀
export const faceImgPrefix = hostsMap['pro'] + '/faceFile/'







// WEBPACK FOOTER //
// ./src/config/env.js